module.exports = __webpack_public_path__ + "static/media/user-cog-solid.f6485bc7.svg";